import { ROLES } from './Constants';

export const getEmptyCheckFn = (userRole) =>
  userRole === ROLES.WRITER
    ? (str) => !str?.length || str === '\n' || str === '\r'
    : (str) => !str?.length;

export const isPremiumContent = (content, orderType, userRole) => {
  if (!content || orderType !== 'PREMIUM') return false;

  const isEmpty = getEmptyCheckFn(userRole);

  const hasValidURL = !isEmpty(content.url);
  const hasText = !isEmpty(content.initialTextContent);

  // Writer & Admin: Require text content
  if (userRole === ROLES.WRITER || userRole === ROLES.ADMIN) {
    return hasValidURL && hasText;
  }

  // Client & Consultant: Accept text OR HTML
  return hasValidURL && (hasText || !isEmpty(content.initialHtmlContent));
};

export const hasInitialContent = (content, userRole) => {
  if (!content) return false;

  const isEmpty = getEmptyCheckFn(userRole);

  return (
    !isEmpty(content.initialTextContent) || !isEmpty(content.initialHtmlContent)
  );
};
